import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { gql, useMutation } from "@apollo/client";
import { Grid, FormDialog, TextField, Select, MenuItem, FormControl, InputLabel } from "../../mui";
import { OperationType, CalculationType } from "../../../utils/enums";
import { ContentActions, ContentTypography } from "../content";
import { FieldsSelect } from "../selects";
import constants from "../../../utils/constants";
import { camelCaseToWords } from "../../../utils/common";
const ADD_STAT = gql `
  mutation AddStatistic($data: statisticInput!) {
    addStatistic(data: $data) {
      id
    }
  }
`;
const EDIT_STAT = gql `
  mutation EditStatistic($id: ID!, $data: statisticInput!) {
    editStatistic(id: $id, data: $data) {
      id
    }
  }
`;
const REMOVE_STAT = gql `
  mutation RemoveStatistic($id: ID!) {
    removeStatistic(id: $id) {
      success
    }
  }
`;
export const ManageStat = ({ stat = null, editStat = () => null, modelName = "" }) => {
    return (_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 9, children: _jsx(ContentTypography, { field: "manageStatTitle" }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { fullWidth: true, name: "label", value: stat?.label, label: _jsx(ContentTypography, { field: "labelText" }), onChange: (e) => editStat(e, stat), size: "small" }) }), _jsx(Grid, { item: true, xs: 6, children: _jsxs(FormControl, { style: { width: "100%" }, children: [_jsx(InputLabel, { children: _jsx(ContentTypography, { field: "operationLabel" }) }), _jsx(Select, { fullWidth: true, name: "operation", value: stat?.operation, label: _jsx(ContentTypography, { field: "selectOperationLabel" }), onChange: (e) => editStat(e, stat), size: "small", children: Object.keys(OperationType)?.map((type, index) => (_jsx(MenuItem, { value: OperationType[type], children: camelCaseToWords(type) }, index))) })] }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FieldsSelect, { fullWidth: true, name: "fieldName", value: stat?.fieldName, label: _jsx(ContentTypography, { field: "selectFieldLabel" }), onChange: (e) => editStat(e, stat), size: "small", modelName: modelName }) }), _jsx(Grid, { item: true, xs: 6, children: _jsxs(FormControl, { style: { width: "100%" }, children: [_jsx(InputLabel, { children: "Calculation" }), _jsx(Select, { name: "calculation", value: stat?.calculation, label: _jsx(ContentTypography, { field: "selectCalculationLabel" }), onChange: (e) => editStat(e, stat), size: "small", children: Object.keys(CalculationType)?.map((type, index) => (_jsx(MenuItem, { value: CalculationType[type], children: camelCaseToWords(type) }, index))) })] }) }), stat?.calculation && stat?.calculation !== "" ? (_jsx(Grid, { item: true, xs: 6, children: _jsx(TextField, { fullWidth: true, name: "calculationValue", value: stat?.calculationValue, label: _jsx(ContentTypography, { field: "calculationValueLabel" }), onChange: (e) => editStat(e, stat), size: "small" }) })) : null] }));
};
const ManagePoolStatsDialog = ({ openManageStats = true, setManageStats = () => null, setSnackBar = () => null, organizationModelId = null, modelName = "", }) => {
    const organizationId = localStorage.getItem("organizationId") || null;
    const [addStatistic] = useMutation(ADD_STAT, {
        refetchQueries: ["StatisticsDialog"],
    });
    const [editStatistic] = useMutation(EDIT_STAT, {
        refetchQueries: ["StatisticsDialog"],
    });
    const [removeStatistic] = useMutation(REMOVE_STAT, {
        refetchQueries: ["StatisticsDialog"],
    });
    const onStatSave = () => {
        let data = { ...openManageStats.stat, organizationModelId, organizationId, modelName };
        if (openManageStats.action === constants.OPERATION_TYPE.ADD) {
            addStatistic({
                variables: { data },
                onCompleted: () => setSnackBar({
                    open: true,
                    message: `Added a new Stat successfully!!`,
                    type: "success",
                }),
                onError: () => setSnackBar({
                    open: true,
                    message: `${getContent("errorMessage")}`,
                    type: "error",
                }),
            });
        }
        if (openManageStats.action === constants.OPERATION_TYPE.EDIT) {
            const id = data.id;
            delete data?.id;
            delete data?.value;
            delete data?.__typename;
            editStatistic({
                variables: { id, data },
                onCompleted: () => setSnackBar({
                    open: true,
                    message: `Updated Stat successfully!!`,
                    type: "success",
                }),
                onError: () => setSnackBar({
                    open: true,
                    message: `${getContent("errorMessage")}`,
                    type: "error",
                }),
            });
        }
        setManageStats({
            open: false,
            stat: null,
            action: null,
        });
    };
    const editStat = (event) => {
        let stat = { ...openManageStats.stat };
        if (event.target.name === "selected") {
            stat.selected = event.target.checked;
        }
        else {
            stat[event.target.name] = event.target.value;
        }
        setManageStats({
            ...openManageStats,
            stat,
        });
    };
    const onStatDelete = () => {
        removeStatistic({
            variables: { id: openManageStats?.stat?.id },
            onCompleted: () => setSnackBar({
                open: true,
                message: `Removed Stat successfully!!`,
                type: "info",
            }),
            onError: () => setSnackBar({
                open: true,
                message: `${getContent("errorMessage")}`,
                type: "error",
            }),
        });
        setManageStats({
            open: false,
            stat: null,
            action: null,
        });
    };
    return (_jsx(FormDialog, { open: openManageStats.open, setOpen: () => setManageStats({
            open: false,
            stat: null,
            action: null,
        }), title: "Statistic", actions: _jsx(ContentActions, { onClose: () => setManageStats({
                open: false,
                stat: null,
                action: null,
            }), onSave: onStatSave, onDelete: openManageStats.action === constants.OPERATION_TYPE.EDIT ? onStatDelete : null }), children: _jsx(ManageStat, { stat: openManageStats?.stat, editStat: editStat, modelName: modelName }) }));
};
export default ManagePoolStatsDialog;
